'use client'

import NotFound from '@layoutpage/not-found'
export default NotFound